/**
 * A stated fact with no control beside it.
 *
 * Visually distinct from a setting on purpose: no border, no chevron, nothing
 * that invites a click. If something on this screen looks pressable it has to
 * do something, and this is what everything that does nothing looks like.
 */
export function Fact({ label, value }: { label: string; value: string }) {
  return (
    <div className="settings__row">
      <span className="settings__row-label">{label}</span>
      <span className="settings__row-value">{value}</span>
    </div>
  );
}
